import { useSelector } from "react-redux";
import { firstUppercase, spaceInCamel } from "../../../../../helpers";
import LogoTool from "../tools/Logo.Tool";
import SidebarMenuItemTool from "../tools/SidebarMenuItem.Tool";
import SidepanelTool from "../tools/Sidepanel.Tool";
import NoSelect from "../../../../../assets/images/information-1.svg";
import PreviewTool from "../tools/Preview.Tool";
import PreviewPanelHeaderTool from "../tools/PreviewPanelHeader.Tool";

const SettingPannel = () => {
  const { theme, colors, selectedElement } = useSelector(
    (state) => state?.themeProvider
  );

  return (
    <>
      {selectedElement ? (
        <div className="space-y-5 bg-slate-200 h-fit rounded-lg p-4">
          {selectedElement && (
            <div className="font-semibold sticky top-0 bg-slate-200 text-lg flex items-center gap-1 whitespace-nowrap">
              {firstUppercase(spaceInCamel(selectedElement))}
              <span>settings</span>
            </div>
          )}
          {selectedElement === "sidePanel" && (
            <SidepanelTool element={"sidePanel"} />
          )}
          {selectedElement === "logo" && <LogoTool element={"logo"} />}
          {selectedElement === "menuItem" && (
            <SidebarMenuItemTool element={"menuItem"} />
          )}
          {selectedElement === "previewPanel" && (
            <PreviewTool element={"previewPanel"} />
          )}
          {selectedElement === "previewPanelHeader" && (
            <PreviewPanelHeaderTool element={"previewPanelHeader"} />
          )}
        </div>
      ) : (
        <div className="bg-white h-fit rounded-lg p-4 flex flex-col space-y-5 items-center justify-center">
          <img alt="no-select" src={NoSelect} />
          <div>No component selected</div>
        </div>
      )}
    </>
  );
};

export default SettingPannel;
